<script>
import { authComputed } from '@state/helpers'
import http from "@state/http";
import MetisMenu from 'metismenujs/dist/metismenujs'
import store from "../state/store";

export default {
  components: {},
  data() {
    return {
      trainee_id: '',
      trainee_info: {},
    }
  },
  computed: {
    ...authComputed,
    userPermission() {
      return this.$store.state.user
    },
    userRole() {
      return this.$store.state.role
    }
  },
  mounted: function () {
    this.trainee_id = this.$route.params.trainee_id;
    this.getTraineeInfo();


    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu')
    var links = document.getElementsByClassName('side-nav-link-ref')
    var matchingMenuItem = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active')
        const parent2 = parent.parentElement
        if (parent2) {
          parent2.classList.add('in')
        }
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add('active')
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }

        const parent4 = parent3.parentElement
        if (parent4) parent4.classList.add('in')
        const parent5 = parent4.parentElement
        if (parent5) parent5.classList.add('active')
      }
    }


  },
  methods: {
    getTraineeInfo() {
      let trainee_id = this.$route.params.trainee_id;
      http.get("api/trainee/profile/name/" + trainee_id).then(response => {
        this.flag = true;
        this.trainee_info = response.data.trainee_info;
      });
    },
    /**
     * small sidebar
     */
    smallSidebar() {
      document.body.classList.add('left-side-menu-sm')
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.remove('topbar-light')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('enlarged')
    },

    /**
     * Dark sidebar
     */
    darkSidebar() {
      document.body.classList.remove('left-side-menu-sm')
      document.body.classList.add('left-side-menu-dark')
      document.body.classList.remove('topbar-light')
      document.body.classList.remove('boxed-layout')
    },

    /**
     * Light Topbar
     */
    lightTopbar() {
      document.body.classList.add('topbar-light')
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.remove('left-side-menu-sm')
      document.body.classList.remove('boxed-layout')
    },

    /**
     * Sidebar collapsed
     */
    sidebarCollapsed() {
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.remove('left-side-menu-sm')
      document.body.classList.toggle('enlarged')
      document.body.classList.remove('boxed-layout')
      document.body.classList.remove('topbar-light')
    },

    /**
     * Boxed Layout
     */
    boxedLayout() {
      document.body.classList.add('boxed-layout')
      document.body.classList.remove('left-side-menu-dark')
      document.body.classList.add('enlarged')
      document.body.classList.remove('left-side-menu-sm')
    },
  },
  created() {
    if (store.getters['auth/loggedIn']) {
      this.$store.dispatch('getUserPermission')
      this.$store.dispatch('getUserRole')
    }
  },
}
</script>

<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul id="side-menu" class="metismenu">
      <li v-if="Object.keys(trainee_info).length !== 0" class="menu-title" style="color: #00B4D3">{{ trainee_info.rep_name
        ? trainee_info.rep_name : trainee_info.name }}</li>
      <li>
        <router-link tag="a" to="/">
          <i class="fe-home"></i>
          <span>Back to Home</span>
        </router-link>
      </li>
      <li>
        <router-link tag="a" :to="{ name: 'traineeProfileInfo', params: { trainee_id: trainee_id } }" active-class="active">
          <i class="fe-file"></i>
          Profile Info
        </router-link>
      </li>
      <li>
        <router-link tag="a" :to="{ name: 'traineeProfileDocument', params: { trainee_id: trainee_id } }"
          active-class="active">
          <i class="fe-file"></i>
          Document
        </router-link>
      </li>
      <li>
        <router-link tag="a" :to="{ name: 'traineeProfileBatch', params: { trainee_id: trainee_id } }" active-class="active">
          <i class="fe-users"></i>
          Batch
        </router-link>
      </li>
      <li>
        <router-link tag="a" :to="{ name: 'traineeProfileAttendance', params: { trainee_id: trainee_id } }"
          active-class="active">
          <i class="fe-check"></i>
          Attendance
        </router-link>
      </li>
      <li>
        <router-link tag="a" :to="{ name: 'traineeProfileBank', params: { trainee_id: trainee_id } }" active-class="active">
          <i class="fe-briefcase"></i>
          Bank
        </router-link>
      </li>
      <li>
        <router-link tag="a" :to="{ name: 'traineeProfileVoucher', params: { trainee_id: trainee_id } }"
          active-class="active">
          <i class="fe-file-text"></i>
          Voucher
        </router-link>
      </li>
      <li>
        <router-link tag="a" :to="{ name: 'traineeProfileFollowup', params: { trainee_id: trainee_id } }"
          active-class="active">
          <i class="fe-book"></i>
          Followup
        </router-link>
      </li>
      <li>
        <router-link tag="a" :to="{ name: 'traineeProfileGrade', params: { trainee_id: trainee_id } }" active-class="active">
          <i class="fe-file-text"></i>
          Exam Grade
        </router-link>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- End Sidebar -->
</template>

<style lang="scss">@import '~metismenujs/scss/metismenujs';</style>
